import { FC } from 'react'

import { RegStep } from '../../data'

import styles from './new-reg-btn.module.scss'

interface INewRegBtn {
  setStep: React.Dispatch<React.SetStateAction<RegStep>>
}

const NewRegBtn: FC<INewRegBtn> = ({ setStep }) => {
  const clickHandler = () => {
    setStep(RegStep.NEW_REG_FLOW)
  }
  return (
    <div className={styles.btn} onClick={clickHandler}>
      Зарегистрироваться
    </div>
  )
}

export default NewRegBtn
